import { notification } from "antd";
import { fetchPaymentBankInit } from "./topupService";

export const triggerMiniAppPayment = async (orderCode, amount) => {
  if (!orderCode) return null;

  try {
    const rsPay = await fetchPaymentBankInit({ OrderCode: orderCode });
    console.log(rsPay, "rsPay");

    if (rsPay?.data?.data?.transactionid) {
      console.log(rsPay.data.data.transactionid, 'rsPay.data.data.transactionid');

      window.miniApp?.postMessage(
        JSON.stringify({
          type: "PAYMENT_HUB_TRANSACTION",
          data: {
            id: rsPay.data.data.transactionid,
            merchantCode: "IPASS",
            amount,
          },
        })
      );
    }
  } catch (error) {
    console.error("triggerMiniAppPayment error:", error.response?.data?.err);
    notification.error({
      message: "Thanh toán thất bại",
      description: error.response?.data?.err || "Đã xảy ra lỗi khi thanh toán",
    });
  }
};
